import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import NewSlider from '../../../MediaSlider';
import Picture from '../../../MediaSlider/components/Picture';

import Grid from '../../../Grid';
import GridItem from '../../../GridItem';

import makeClassName from 'shared-utils/src/makeClassName';
import createStyle from 'shared-utils/src/createStyle';
import LockScreen from 'shared-utils/src/lockScreen';

import { Icon } from 'shared-vectors';
import Arrow from 'shared-vectors/icons/GalleryArrowSml';
import style, { mainCls } from './style';
import Header from './Header';
import Footer from './Footer';

const useStyles = createStyle(style);

const FloorplanOverlay = ({
  floorplans = [],
  current: curr = 0,
  setSlider = () => { },
  coordsOnClick,
  uri,
  setCurrentFloorplan,
  createSpecificModal,
  sendMail,
  title,
  priceEl,
  device,
  viewportW,
  loadDetail,
  isBlurred,
}) => {
  const cls = useStyles();
  const URLIMAGES = 'https://images-1.casa.it/';
  const [current, setCurrent] = useState(curr);
  const [isUp, setIsUp] = useState(false);
  const [lockScreen, setLockScreen] = useState(null);
  const [isHidden, setIsHidden] = useState(false);
  const [modalIsGoinDown, setModalIsGoinDown] = useState(false);
  const moreThanOne = floorplans?.length > 1;
  // const [isOChanging, setIsOChanging] = useState(false);
  const [initialSlide] = useState(current);

  const slider = useRef(null);

  const popStateClose = (e) => {
    e.preventDefault();
    closeFirstModal(true);
  };

  useEffect(() => {
    setLockScreen(new LockScreen('floorplan-locked'));
    setTimeout(() => setIsUp(true)); // dice al contenitore di animarsi

    window.addEventListener('popstate', popStateClose);

    return () => {
      window.removeEventListener('popstate', popStateClose);
    };
  }, []);

  const prevSlide = () => slider.current.slickPrev();
  const nextSlide = () => slider.current.slickNext();

  useEffect(() => {
    if (lockScreen) {
      if (isUp) {
        lockScreen.lock(null, coordsOnClick);
      }
    }
    return () => {
      lockScreen && lockScreen.unLock(null, coordsOnClick);
    };
  }, [isUp, lockScreen]);

  useEffect(() => setSlider(slider.current), []);

  const updateCurrent = (newCurrent) => {
    setCurrent(newCurrent);
  };

  const modCls = makeClassName([
    cls[`${mainCls}__modale`],
    isUp && `${mainCls}__modale--up`,
    modalIsGoinDown && `${mainCls}__modale--down`,
  ]);

  const callOpenSpecificModal = ({ forcedPosition }) => {
    sendMail({ forcedPosition });
  };
  const closeFirstModal = (e) => {
    lockScreen && lockScreen.unLock(null, coordsOnClick);
    setModalIsGoinDown(true);
    setTimeout(() => {
      setIsUp(false);
      setTimeout(() => {
        setCurrentFloorplan({
          showFloorplan: false,
          floorplans: [],
          current: 0,
          uri: '',
        });
      }, 250);
    });
  };
  const ctnCls = makeClassName([
    `${cls[mainCls]}__slide`,
    'tp-a--c',
    'is-rel',
    isBlurred && 'blur',
  ]);

  return (
    <div className={cls[mainCls]}>
      <Grid direction="column" className={modCls}>
        <GridItem behavior="fixed" className={cls[`${mainCls}__header`]}>
          <Header
            slider={floorplans}
            activeMedia={current}
            closeModal={closeFirstModal}
            uri={uri}
            createSpecificModal={createSpecificModal}
            callOpenSpecificModal={callOpenSpecificModal}
            loadDetail={loadDetail}
          />
        </GridItem>
        <div className={ctnCls}>
          <Grid
            style={isHidden ? { opacity: 0 } : null}
            className={cls[`${mainCls}__body`]}
            direction="column"
          >
            <GridItem>
              <Grid className={cls[`${mainCls}__bod`]}>
                <GridItem
                  className={cls[`${mainCls}__arrowCol`]}
                  behavior="fixed"
                >
                  {moreThanOne &&
                    <button
                      type="button"
                      className={`${cls[`${mainCls}__arrow`]} c-txt--f2 c-bg--w b-r--pill is-clickable`}
                      onClick={prevSlide}
                    >
                      <Icon name={Arrow} />
                    </button>
                  }
                </GridItem>
                <GridItem className="is-rel">
                  <div className={cls[`${mainCls}__slider`]}>
                    <NewSlider
                      blockVerticalScroll
                      sliderRef={slider}
                      initialSlide={initialSlide}
                      onChangeIndex={updateCurrent}
                      keyboardEvts
                      arrows={device !== 'desktop' && viewportW < 1024}
                      infinite
                      zoom
                      fromFloorplanSrp
                    >
                      {floorplans.map((slide, i) => {
                        return (
                          <Picture
                            key={`slide__${i}`}
                            data={{
                              baseUri: URLIMAGES,
                              uri: slide.uri,
                            }}
                          />
                        );
                      })}
                    </NewSlider>
                  </div>
                </GridItem>
                <GridItem
                  className={cls[`${mainCls}__arrowCol`]}
                  behavior="fixed"
                >
                  {moreThanOne &&
                    <button
                      type="button"
                      className={`${cls[`${mainCls}__arrow`]} c-txt--f2 c-bg--w b-r--pill is-clickable next`}
                      onClick={nextSlide}
                    >
                      <Icon name={Arrow} className="is-rot-180" />
                    </button>
                  }
                </GridItem>
              </ Grid>
            </GridItem>
          </Grid>
        </div>
        <GridItem behavior="fixed" className={cls[`${mainCls}__footer`]}>
          <Footer
            slider={floorplans}
            activeMedia={current}
            closeModal={closeFirstModal}
            uri={uri}
            createSpecificModal={createSpecificModal}
            callOpenSpecificModal={callOpenSpecificModal}
            title={title}
            priceEl={priceEl}
            device={device}
            viewportW={viewportW}
            loadDetail={loadDetail}
          />
        </GridItem>
      </Grid >
    </div >
  );
};

export default FloorplanOverlay;

FloorplanOverlay.propTypes = {
  floorplans: PropTypes.instanceOf(Array),
  current: PropTypes.number,
  setCurrent: PropTypes.func,
  isBlurred: PropTypes.bool,
  setSlider: PropTypes.func,
  coordsOnClick: PropTypes.func,
};

FloorplanOverlay.defaultProp = {
  floorplans: [],
  current: 0,
  setCurrent: () => { },
  isBlurred: false,
  setSlider: () => { },
  coordsOnClick: () => { },
};
